export enum TitleGroup {
  EazeeApp = 'EazeeApp',
  GlobalWarrantyCorporation = 'GlobalWarrantyCorporation'
}
